import { APP_INITIALIZER, NgModule } from '@angular/core';
import {
  provideTransloco,
  TranslocoModule,
  TranslocoService,
} from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { TranslocoHttpLoader } from './transloco-loader';

export function preloadTranslation(transloco: TranslocoService) {
  return function () {
    // Detect browser language, fallback to 'en' if not supported
    const supportedLangs = ['en', 'nl', 'de', 'fr'];
    let browserLang = (navigator.languages && navigator.languages[0]) || navigator.language || 'en';
    browserLang = browserLang.split('-')[0]; // Use only the language code
    const langToSet = supportedLangs.includes(browserLang) ? browserLang : 'en';
    transloco.setActiveLang(langToSet);
    return firstValueFrom(transloco.load(langToSet));
  };
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'nl', 'de', 'fr'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [TranslocoService],
      useFactory: preloadTranslation,
    },
  ],
})
export class TranslocoRootModule {}
